import _toConsumableArray from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _get from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "C:/Users/eric.sangabriel/Documents/GitHub/web/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { MediaChromeButton } from "./media-chrome-button.js";
import { globalThis, document } from "./utils/server-safe-globals.js";
import { MediaUIEvents, MediaUIAttributes } from "./constants.js";
import { verbs } from "./labels/labels.js";
import { getBooleanAttr, setBooleanAttr } from "./utils/element-utils.js";
var MEDIA_TIME_IS_LIVE = MediaUIAttributes.MEDIA_TIME_IS_LIVE,
    MEDIA_PAUSED = MediaUIAttributes.MEDIA_PAUSED;
var MEDIA_SEEK_TO_LIVE_REQUEST = MediaUIEvents.MEDIA_SEEK_TO_LIVE_REQUEST,
    MEDIA_PLAY_REQUEST = MediaUIEvents.MEDIA_PLAY_REQUEST;
var indicatorSVG = '<svg viewBox="0 0 6 12"><circle cx="3" cy="6" r="2"></circle></svg>';
var slotTemplate = document.createElement("template");
slotTemplate.innerHTML = "\n  <style>\n\n  slot[name=indicator] > *,\n  :host ::slotted([slot=indicator]) {\n    ".concat("\n    min-width: auto;\n    fill: var(--media-live-button-icon-color, rgb(140, 140, 140));\n    color: var(--media-live-button-icon-color, rgb(140, 140, 140));\n  }\n\n  :host([", MEDIA_TIME_IS_LIVE, "]:not([").concat(MEDIA_PAUSED, "])) slot[name=indicator] > *,\n  :host([").concat(MEDIA_TIME_IS_LIVE, "]:not([").concat(MEDIA_PAUSED, "])) ::slotted([slot=indicator]) {\n    fill: var(--media-live-button-indicator-color, rgb(255, 0, 0));\n    color: var(--media-live-button-indicator-color, rgb(255, 0, 0));\n  }\n\n  :host([").concat(MEDIA_TIME_IS_LIVE, "]:not([").concat(MEDIA_PAUSED, "])) {\n    cursor: not-allowed;\n  }\n\n  </style>\n\n  <slot name=\"indicator\">").concat(indicatorSVG, "</slot>\n  ", "\n  <slot name=\"spacer\">&nbsp;</slot><slot name=\"text\">LIVE</slot>\n");

var updateAriaAttributes = function updateAriaAttributes(el) {
  var isPausedOrNotLive = el.mediaPaused || !el.mediaTimeIsLive;
  var label = isPausedOrNotLive ? verbs.SEEK_LIVE() : verbs.PLAYING_LIVE();
  el.setAttribute("aria-label", label);
  isPausedOrNotLive ? el.removeAttribute("aria-disabled") : el.setAttribute("aria-disabled", "true");
};

var MediaLiveButton = /*#__PURE__*/function (_MediaChromeButton) {
  _inherits(MediaLiveButton, _MediaChromeButton);

  var _super = _createSuper(MediaLiveButton);

  function MediaLiveButton() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, MediaLiveButton);

    return _super.call(this, _objectSpread({
      slotTemplate: slotTemplate
    }, options));
  }

  _createClass(MediaLiveButton, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      updateAriaAttributes(this);

      _get(_getPrototypeOf(MediaLiveButton.prototype), "connectedCallback", this).call(this);
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(attrName, oldValue, newValue) {
      _get(_getPrototypeOf(MediaLiveButton.prototype), "attributeChangedCallback", this).call(this, attrName, oldValue, newValue);

      updateAriaAttributes(this);
    }
  }, {
    key: "mediaPaused",
    get: function get() {
      return getBooleanAttr(this, MediaUIAttributes.MEDIA_PAUSED);
    },
    set: function set(value) {
      setBooleanAttr(this, MediaUIAttributes.MEDIA_PAUSED, value);
    }
  }, {
    key: "mediaTimeIsLive",
    get: function get() {
      return getBooleanAttr(this, MediaUIAttributes.MEDIA_TIME_IS_LIVE);
    },
    set: function set(value) {
      setBooleanAttr(this, MediaUIAttributes.MEDIA_TIME_IS_LIVE, value);
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      if (!this.mediaPaused && this.mediaTimeIsLive) return;
      this.dispatchEvent(new globalThis.CustomEvent(MEDIA_SEEK_TO_LIVE_REQUEST, {
        composed: true,
        bubbles: true
      }));

      if (this.hasAttribute(MEDIA_PAUSED)) {
        this.dispatchEvent(new globalThis.CustomEvent(MEDIA_PLAY_REQUEST, {
          composed: true,
          bubbles: true
        }));
      }
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return [].concat(_toConsumableArray(_get(_getPrototypeOf(MediaLiveButton), "observedAttributes", this)), [MEDIA_PAUSED, MEDIA_TIME_IS_LIVE]);
    }
  }]);

  return MediaLiveButton;
}(MediaChromeButton);

if (!globalThis.customElements.get("media-live-button")) {
  globalThis.customElements.define("media-live-button", MediaLiveButton);
}

var media_live_button_default = MediaLiveButton;
export { media_live_button_default as default };